import DataGrid from '@src/components/data.grid'
import React from 'react'
import { getDatailColumns } from '../../configurations'
import type { History } from 'history'
import { isEmpty } from 'lodash'
import { CSSSelector } from '@src/utils/css.selector.helper'
import * as Selectors from '../../selectors'
import * as CommonSelectors from '@src/selectors'
import { useDispatch, useSelector } from 'react-redux'
import {
  autocompleteSessionSearch,
  closeCurrentSession,
  changeBatchSize,
  nextAutocompleteSessionSearch,
  prevAutocompleteSessionSearch
} from '@src/redux/actions/autocomplete.actions'
import WaitFeatureFlags from '../../../feature.flags/components/wait.feature.flags'

interface OwnProps {
  history: History
}

export type Props = OwnProps

type SearchResultComponent<T> = React.FC<T> & {
  CSSSelectors?: {
    searchResultTable: CSSSelector
  }
}

const SearchResult: SearchResultComponent<Props> = React.memo(
  (props: Props) => {
    const { history } = props
    const dispatch = useDispatch()

    const table = useSelector(Selectors.GetAutocompleteTable)
    const resourceTypes = useSelector(CommonSelectors.getResourceTypes)
    const isPending = useSelector(Selectors.getIsPending)
    const batchSize = useSelector(Selectors.getBatchSize)
    const hasNext = useSelector(Selectors.getHasNext)
    const hasPrev = useSelector(Selectors.getHasPrev)

    React.useEffect(
      () => () => {
        dispatch(closeCurrentSession())
      },
      []
    )

    const onFetchData = (parseAccesPathName: boolean) => (state, instance) => {
      if (!isEmpty(table)) {
        dispatch(autocompleteSessionSearch({ batchSize: state.pageSize }))
      } else if (batchSize !== state.pageSize) {
        dispatch(changeBatchSize(state?.pageSize))
      }
    }

    function onNext() {
      dispatch(nextAutocompleteSessionSearch())
    }

    function onPrev() {
      dispatch(prevAutocompleteSessionSearch())
    }

    return (
      <WaitFeatureFlags flags={['CAM_TEMP_20201120_SCOPED_ROLE']}>
        {({ CAM_TEMP_20201120_SCOPED_ROLE }) => (
          <DataGrid
            hideEmptyColumns
            gridId={SearchResult.CSSSelectors.searchResultTable.value}
            resourceTypes={resourceTypes}
            title={'Total Access Paths'}
            data={table}
            columns={getDatailColumns(
              history,
              CAM_TEMP_20201120_SCOPED_ROLE?.response?.value
            )}
            onFetchData={onFetchData(false)}
            efficientPaging
            loading={isPending}
            onPrevPage={onPrev}
            onNextPage={onNext}
            canNext={hasNext}
            canPrev={hasPrev}
            rowsPerPage={batchSize}
            sortable={false}
          />
        )}
      </WaitFeatureFlags>
    )
  }
)

SearchResult.CSSSelectors = {
  searchResultTable: new CSSSelector('searchResultTable')
}

export default SearchResult
